export type InterventionType = 'Installation' | 'Repair' | 'Removal' | 'Unknown';
export type EquipmentType = 'CoffeeMachine' | 'WaterFountain' | 'StoreFurniture' | 'FreefoodFurniture' | 'Unknown';

const typeMapper: Record<InterventionType, string> = {
    Installation: 'Installation',
    Repair: 'Réparation',
    Removal: 'Retrait',
    Unknown: 'Installation',
};

const equipmentMapper: Record<EquipmentType, string> = {
    CoffeeMachine: "d'une machine à café",
    WaterFountain: "d'une fontaine à eau",
    StoreFurniture: "d'un meuble du magasin",
    FreefoodFurniture: "d'un meuble du magasin",
    Unknown: "d'un équipement",
};

export const getInterventionText = (type: InterventionType = 'Unknown', equipment: EquipmentType = 'Unknown'): string =>
    `${typeMapper[type]} ${equipmentMapper[equipment]}`;
